module.exports = __webpack_public_path__ + "img/Ati_round.a94947c1.png";